import React from 'react';
import classNames from 'classnames';

const ns = 'product-option';

const Option = ({
	groupIndex,
	value,
	doesExist,
	isInStock,
	setFilter,
	selected,
}) => {
	function handleClick(e) {
		e.preventDefault();

		//	Do nothing if it's already selected.
		if (selected || !doesExist) {
			return;
		}

		setFilter(groupIndex, selected ? null : value);
	}

	const rootClassnames = classNames({
		[`${ ns }`]: true,
		[`${ ns }--button`]: true,
		[`out-of-stock`]: !isInStock,
		[`${ ns }--does-not-exist`]: !doesExist,
		selected,
	});

	return (
		<button
			className={rootClassnames}
			onClick={handleClick}
		>
			{value}
		</button>
	);
};

export default Option;
